import { FEEDBACK } from '../constants';
import { instance } from '../../axios';

const getFeedbacksAction = (companyId) => {
  return (dispatch) => {
    dispatch({
      type: FEEDBACK.GET_FEEDBACK,
    });
    instance
      .get('/feedback?company_id=' + companyId)
      .then((results) => {
        dispatch({
          type: FEEDBACK.GET_FEEDBACK_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: FEEDBACK.GET_FEEDBACK_FAILURE,
          payload: error,
        });
      });
  };
};

export { getFeedbacksAction };
